import React, { useState } from 'react';
import { X, RefreshCw } from 'lucide-react';

interface LiveStreamViewerProps {
  rtspUrl: string;
  cameraName: string;
  cameraId?: string;
  onClose: () => void;
}

const LiveStreamViewer: React.FC<LiveStreamViewerProps> = ({ cameraName, cameraId, onClose }) => {
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  const token = localStorage.getItem('csense_auth_token');
  const streamSrc = cameraId ? `/api/cameras/${cameraId}/live-stream?token=${encodeURIComponent(token || '')}&r=${reloadKey}` : '';

  const retry = () => {
    setError(null);
    setReloadKey(k => k + 1);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
      <div className="bg-gray-900 rounded-lg p-4 w-full max-w-4xl mx-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold text-white">{cameraName}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Video Container */}
        <div className="relative bg-black rounded-lg overflow-hidden" style={{ aspectRatio: '16/9' }}>
          {!cameraId || error ? (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center text-white px-6">
                <p className="text-red-400 mb-4">{error || 'No stream available for this camera.'}</p>
                <button
                  onClick={retry}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg inline-flex items-center gap-2"
                >
                  <RefreshCw className="w-4 h-4" /> Retry
                </button>
              </div>
            </div>
          ) : (
            <img
              key={reloadKey}
              src={streamSrc}
              alt={cameraName}
              className="w-full h-full object-cover"
              onError={() => setError('Camera is unreachable right now.')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveStreamViewer;
